@if (isNewEDPScoreboard) {
    <div class="darts-scoreboard">
        <ng-container *ngTemplateOutlet="dartsScoreboard" />
    </div>
    <div class="score-container">
        <ms-score-card
            [eventId]="event.id"
            [participant1Score]="score.participant1.toString()"
            [participant2Score]="score.participant2.toString()"
            [showSeparator]="false" />
    </div>
} @else {
    <ng-container *ngTemplateOutlet="dartsScoreboard" />
}
<ng-template #dartsScoreboard>
    @for (participant of event.participants; let i = $index; track participant) {
        <div class="participant">
            <ms-participant-image [participantImage]="event.participants[i].image" [sportId]="event.sport.id" />
            <ms-scoreboard-participant
                class="participant-info"
                [event]="event"
                [participant]="event.participants[i]"
                [isNewEDPScoreboard]="isNewEDPScoreboard"
                [showIndicator]="false" />
            @if (score.currentlyServing === i + 1) {
                @if (isNewEDPScoreboard) {
                    <vn-icon name="sports-sb-darts" class="darts-icon" width="14" height="16" />
                } @else {
                    <div
                        [ngClass]="{
                            'serving-indicator': !isNewEDPScoreboard,
                        }"></div>
                }
            }
            @if (score.matchType === 1 && !isNewEDPScoreboard) {
                <div class="set darts-indicator">{{ setsScore[i] }}</div>
            }
            @if (score.legs) {
                <div class="set normal-points" [class.darts-indicator]="score.matchType === 0" [class.legs]="isNewEDPScoreboard">
                    {{ legsScore[i] }}
                </div>
            }
            @if (score.hundredEighties) {
                <div class="set normal-points">{{ oneEightysScore[i] }}</div>
            }
        </div>
    }
    <div class="participant-footer">
        <div class="participant-info-darts">
            @if (isNewEDPScoreboard) {
                <i class="live-icon"></i>
            }
            <div class="best-of">
                <ms-best-of [scoreboard]="event.scoreboard" />
                <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
            </div>
            @if (score.matchType === 1 && !isNewEDPScoreboard) {
                <span class="sets-label"> {{ sitecoreEventDetails.eventDetails.Sets }} </span>
            }
            @if (score.legs) {
                <span class="legs-label"> {{ sitecoreEventDetails.eventDetails.Legs }} </span>
            }
            @if (score.hundredEighties) {
                <span class="hundred-eighties-label">
                    {{ sitecoreEventDetails.eventDetails.HundredEighties }}
                </span>
            }
        </div>
    </div>
    <div class="header">
        <div class="set-score">
            @if (score.matchType === 1) {
                {{ sitecoreEventDetails.eventDetails.Sets }} {{ score.participant1 }} : {{ score.participant2 }}
            }
            @if (score.matchType === 0) {
                {{ sitecoreEventDetails.eventDetails.Legs }} {{ score.legs.participant1 }} : {{ score.legs.participant2 }}
            }
        </div>
        <div class="event-time">
            <div class="set-point">
                {{ event.scoreboard.period?.name }}
                @if (score.matchType === 1) {
                    <span> {{ score.legs.participant1 }} : {{ score.legs.participant2 }} </span>
                }
            </div>
        </div>
    </div>
</ng-template>
